/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useNavigate } from "react-router-dom";
import "./home.css";

const HomePage = () => {
  const navigate = useNavigate();

  const tools = [
    {
      icon: "/icons/Info.png",
      title: "INFO",
      path: "/info",
      description:
        "Understand How Government Works Through Simple, Clear Explanations Of Political Processes.",
    },
    {
      icon: "/icons/checker.png",
      title: "AI Fact Checker",
      path: "/ask",
      description:
        "Use Our AI-Powered Tool To Analyze Political Statements And Get Real-Time Fact-Based Answers.",
    },
    {
      icon: "/icons/similar.png",
      title: "SIMILAR",
      path: "/policy-swipe",
      description:
        "Find Politicians Who Share Your Values Based On Their Voting History And Speeches.",
    },
    {
      icon: "/icons/topics.png",
      title: "TOPICS",
      path: "/topics",
      description:
        "Explore Political Topics And Discover Where Leaders Really Stand On The Issues You Care About.",
    },
    {
      icon: "/icons/challenge.png",
      title: "CHALLENGE",
      path: "/challenge",
      description:
        "Test Your Knowledge By Spotting Misinformation And Learning How To Fact-Check Like A Pro.",
    },
  ];

  return (
    <div className="home-page">
      <div className="home-container">
        {/* Header */}
        {/* <div className="navbar">
        <img src="/icons/TrueVoteLogo.png" alt="TrueVote" className="navbar-logo" />
        <div className="nav-links">
          <a href="#">About Us</a>
          <a href="#">Tools & Tips</a>
          <a href="#">How It Works ?</a>
        </div>
      </div> */}
        {/* createa new component to let all pages share the same navigation bar */}

        {/* Hero */}
        <div className="hero">
          <h1 className="hero-title">BE SMART WITH YOUR VOTE</h1>
          <p className="hero-subtitle">
            SO YOU CAN BE CONFIDENT IN YOUR CHOICE
          </p>
          <button className="hero-button" onClick={() => navigate("/ask")}>
            Get Started With Checking Your Facts
          </button>
        </div>

        {/* Tools Section */}
        <div className="tool-prompt">
          Pick A Tool To Begin Exploring Truth, Topics, And Trustworthy
          Insights.
        </div>

        <div className="tool-grid">
          {tools.map((tool, index) => (
            <div key={index} className="tool-wrapper">
              <div className="tool-card" onClick={() => navigate(tool.path)}>
                <img src={tool.icon} alt={tool.title} />
              </div>
              <h3 className="tool-title">{tool.title}</h3>
              <p className="tool-description">{tool.description}</p>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="footer">
          <div className="footer-container">
            <div className="footer-left">
              <img src="/icons/TrueVoteLogo.png" alt="TrueVote Logo" />
              <p>
                TrueVote makes it easy to check the facts, match your values,
                and vote smarter — no political spin, just data.
              </p>
            </div>

            <div className="footer-center">
              {/* <strong>Contact</strong>
              <p>Email: info@truevote.com</p>
              <p>Phone: +61 123 456 789</p> */}
            </div>

            <div className="footer-right">
              {/* <strong>Links</strong> */}
              {/* <ul className="footer-links">
                <li>
                  <a href="#">Privacy Policy</a>
                </li>
                <li>
                  <a href="#">Terms & Conditions</a>
                </li>
                <li>
                  <a href="#">Acknowledgements</a>
                </li>
              </ul> */}
              <strong>Contact</strong>
              <p>Email: info@truevote.com</p>
              <p>Phone: +61 123 456 789</p>
            </div>
          </div>

          <div className="social-icons">
            <img src="/icons/Instagram.png" alt="Instagram" />
            <img src="/icons/Facebook.png" alt="Facebook" />
            <img src="/icons/X.png" alt="X" />
            <img src="/icons/WhatsApp.png" alt="WhatsApp" />
          </div>

          <div className="footer-bottom">
            © 2025 TrueVote. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
